<template>
  <el-form :model="form" ref="form" class="form-box">
    <!-- 标题 -->
    <el-form-item :label="$t('204')" prop="title">
      <el-input disabled type="text" v-model="form.title" :placeholder="$t('i18n.cc2205ac932a4b34b31ec3ef16fbd452')" />
    </el-form-item>
    <!-- 内容 -->
    <el-form-item :label="$t('866')" prop="content">
      <el-radio-group v-model="form.p_type" @change="handleType">
        <el-radio label="1">{{ $t('i18n.ce8221bbeb744a07b79b8956dd1a76cc') }}</el-radio>
        <el-radio label="2">{{ $t('i18n.6ef5b05f521b44158e422e2f8ec9f794') }}</el-radio>
      </el-radio-group>
      <el-form-item>
        <ueditor
          v-show="form.p_type === '1'"
          ref="ueditor"
          id="message-edit-ueditor"
          :key="'message-edit-ueditor'"
          v-model="form.content"
          :action-url="'/app/tool/upload_url'"
          :height="400"
        ></ueditor>
        <el-upload
          v-show="form.p_type === '2'"
          class="upload"
          ref="upload"
          :auto-upload="true"
          :headers="baseHeaders"
          :action="action"
          :multiple="multiple"
          :before-upload="beforeUploadHandle"
          :on-success="successHandle"
          :on-error="handleError"
          :on-remove="handleRemove"
          :file-list="form.file"
          :data="data || null"
          drag
        >
          <i class="el-icon-upload"></i>
          <div>
            <el-button size="small">{{ $t('52') }}</el-button>
          </div>
          <p>
            {{ $t('i18n.f502f233c5d445df93392a7ab3e8dafe', { type: '.pdf' }) }}
          </p>
        </el-upload>
      </el-form-item>
    </el-form-item>
  </el-form>
</template>
<script>
import { baseHeaders } from 'util/axios-request'
import ueditor from '_c/ueditor'
const baseURL = process.env.VUE_APP_BASE_API
export default {
  props: {
    content: {
      type: Object,
      default: () => ({
        title: '',
        content: ''
      })
    }
  },
  components: {
    ueditor
  },
  data() {
    return {
      baseHeaders: baseHeaders(),
      fileFormat: ['.pdf'],
      action: baseURL + 'web/tool/upload_file',
      multiple: true,
      fileLimit: 1,
      rules: {
        title: [{ required: true, message: this.$t('i18n.ce8221bbeb744a07b79b8956dd1a76cc') }],
        content: [{ required: true, message: this.$t('629') }]
      },
      formData: {},
      data: {},
      // 标题 内容
      form: {
        title: this.$t('i18n.cc2205ac932a4b34b31ec3ef16fbd452'),
        content: '',
        file: [],
        p_type: '1'
      },
      loading: false
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.content))
    this.form.p_type = this.form.p_type || '1'
  },
  methods: {
    beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        const fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(
            this.$t('729', {
              fileFormat: this.fileFormat.join()
            })
          )
          return false
        }
      }

      // 文件大小
      // if (!(file.size / 1024 / 1024 < this.fileSize)) {
      //   this.$message.error(
      //     this.$t('730', {
      //       fileSize: this.fileSize
      //     })
      //   )
      //   return false
      // }
    },
    handleType(val) {
      if (val === '1') {
        this.form.file = []
        this.form.file_url = ''
        this.$refs.upload.uploadFiles = []
      } else {
        this.$refs.ueditor.clearHtml()
        this.form.content = ''
      }
    },
    successHandle(res) {
      const list = this.$refs.upload.uploadFiles
      this.$refs.upload.uploadFiles = [list[list.length - 1]]
      this.form.file_url = res.data.object_url
    },
    handleError(err) {
      this.$message.error('upload error')
      throw err
    },
    beforeRemove() {
      return this.$confirm(this.$t('18'), this.$t('19'), {
        confirmButtonText: this.$t('20'),
        cancelButtonText: this.$t('21'),
        type: 'warning'
      })
    },
    // 删除
    handleRemove(e, item) {
      this.form.file.splice(
        this.form.file.findIndex(v => v.object_url === item.object_url),
        1
      )
      this.$refs.upload.uploadFiles.splice(
        this.$refs.upload.uploadFiles.findIndex(v => v.name === item.file_name),
        1
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.el-input {
  min-width: 100%;
}
.upload {
  width: 100%;
  height: 200px;
  .el-icon-upload {
    font-size: 67px;
    color: #c0c4cc;
    line-height: 50px;
  }
  p {
    font-size: 12px;
    color: #606266;
    margin-top: 7px;
  }
  /deep/ .el-upload {
    width: 100%;
    height: 100%;
    .el-upload-dragger {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
